import { render } from "./App.vue?vue&type=template&id=585cc4c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/css/App.css?vue&type=style&index=0&lang=css&external"
import "@/css/plus/layout.css?vue&type=style&index=1&lang=css&external"
import "@/css/plus/componenti.css?vue&type=style&index=2&lang=css&external"
import "@/css/plus/pagine.css?vue&type=style&index=3&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__